/* global */
'use strict';
import './style.less';

export default function($scope, $log, $stateParams, $uibModalInstance, compliance, regulators, filteredLicenses) {
  'ngInject';
  try {
    const profile_uids = Object.keys(compliance.obj);
    const rangeEnd = $stateParams.rangeEnd ? new Date(Number($stateParams.rangeEnd)).toISOString() : undefined;
    const rangeStart = $stateParams.rangeStart ? new Date(Number($stateParams.rangeStart)).toISOString() : undefined;
    const latestRegulatorCompliances = !rangeEnd && !rangeStart ? true : undefined;
    filteredLicenses = filteredLicenses || [];

    $scope.allLicensesReportParams = {
      latestRegulatorCompliances,
      profile_uids,
      rangeEnd,
      rangeStart,
      reg_ids: filteredLicenses.length ? filteredLicenses : undefined
    };

    $scope.allLicensesReportDetailedSummaryParams = {
      ...$scope.allLicensesReportParams,
      includeAnnuals: false,
      includeSummary: false
    };

    $scope.close = () => $uibModalInstance.dismiss('cancel');

    $scope.licenses = compliance.arr
      .filter(({ reg_id }) => (filteredLicenses.length ? filteredLicenses.includes(reg_id) : true))
      .reduce((acc, user) => {
        const { reg_id, reg_date } = user;
        const regulator = regulators.obj[reg_id][reg_date];

        acc[reg_id] = {
          name: regulator.name,
          reportParams: {
            latestRegulatorCompliances,
            profile_uids,
            rangeEnd,
            rangeStart,
            reg_ids: [regulator.reg_id]
          },
          reportDetailedSummaryParams: {
            includeAnnuals: false,
            includeSummary: false,
            latestRegulatorCompliances,
            profile_uids,
            rangeEnd,
            rangeStart,
            reg_ids: [regulator.reg_id]
          }
        };

        return acc;
      }, {});
  } catch (error) {
    $log.error(error);
    throw error;
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/employeesComplianceReport/index.js